import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { set, useForm } from "react-hook-form";

import BoatInfoModalWindow from "./modalWindow/BoatInfoModalWindow";
import EditButton from "./editButton/EditButton";
import EmptyHeaderCell from "./emptyHeaderCell/EmptyHeaderCell";
import EmptyBodyCell from "./emptyBoatCell/EmptyBoatCell";
import AddButton from "./addButton/AddButton";
import UniversalInputComponent from "../../AdministrativeProcedures/commonComponents/universalInputComponent/UniversalInputComponent";
import ConfirmationModal from "../../confirmationModal/confirmationModal";
import ResultModalWindow from "../../AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow";

import {
  clearBoatInfo,
  deleteBoatFile,
  getBoatCardInfo,
  getCheckBoatSerialNumber,
  updateBoatInfoApi,
} from "../../../redux/smallBoatsReducer/actionsSmallBoats";

import {
  getOptionsBoatInfo,
  getOptionsModalWindowBoatInfo,
  handleAddBtn,
  setDocOptionsDocumentsFromDictionaries,
  setOblOptionsFromDictionaries,
  setOptionsBoatInfo,
  setOptionsForBoat,
} from "./optionsBoatInfo";

import styles from "./boatInfo.module.css";

function BoatInfo() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    clearErrors,
    getValues,
  } = useForm();

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });

  const {
    boatInfo: boatInfoFromState,
    checkboatSerialNumber,
    editDataResult,
  } = useSelector((state) => state.smallBoatsReducer);

  const { mode } = location.state;
  const id = window.location.pathname.split("/").at(-1);
  const [options, setOptions] = useState(getOptionsBoatInfo(mode, boatInfoFromState.statusOfApp));
  const [optionsForWindow, setOptionsForWindow] = useState({});
  const [directoryLoad, setDirectoryLoad] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [fileId, setFileId] = useState(null);
  const [showResultModal, setShowResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [formData, setFormData] = useState({});
  const [tableErrors, setTableErrors] = useState({});

  const optionsForOfficer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.usersLibrary.map((item) => {
      return {
        value: item.value,
        label: item.label,
        key: "onOfficer",
      };
    });
  });

  const dictionaryReducer = useSelector((state) => state.dictionaryReducer);

  const userInfo = useSelector((state) => state.dictionaryReducer.userInfo);

  const handleAddNewData = (e, key) => {
    setOptionsForWindow({
      ...getOptionsModalWindowBoatInfo(
        e.currentTarget.getAttribute("data-event"),
        e.currentTarget.id,
        userInfo,
      ),
      mode: e.currentTarget.getAttribute("data-event"),
      key,
    });
    setShowModal(!showModal);
  };
  const handleEditNotes = (e, el, key) => {
    if (e.currentTarget.dataset.event !== undefined) {
      if (e.currentTarget.dataset.event === "edit") {
        setOptionsForWindow({
          ...getOptionsModalWindowBoatInfo(
            e.currentTarget.getAttribute("data-event"),
            e.currentTarget.id,
            userInfo,
            el,
          ),
          mode: e.currentTarget.getAttribute("data-event"),
          rowId: e.currentTarget.getAttribute("data-rowid"),
          key,
          data: { ...el },
        });
        setShowModal(!showModal);
      } else {
        setFileId(el.docid || el.id);
        setShowConfirmationModal(!showConfirmationModal);
      }
    }
  };

  const clearOptionsModalWindow = () => {
    setOptionsForWindow(structuredClone({}));
  };
  const createRow = (option) => {
    function createCell(prop, el) {
      switch (prop.type) {
        case "checkbox": {
          return <span>{el?.[prop.key] ? "Да" : "Нет"}</span>;
        }
        case "link": {
          return <a href={`${prop.url}${el.docid}`}>{el?.[prop.key]}</a>;
        }
        default:
          break;
      }
    }
    if (Array.isArray(boatInfoFromState?.[option?.keyTable])) {
      let additionalRows;
      if (option?.keyTable === "documents") {
        additionalRows = boatInfoFromState.fileList?.map((item) => {
          return (
            <tr key={item.id}>
              <td id={item.id}>{new Date().toLocaleDateString()}</td>
              <td>{item.name}</td>
              {
                <EditButton
                  mode={mode}
                  option={option}
                  el={item}
                  cardStatus={boatInfoFromState?.statusOfApp === 2}
                  handle={handleEditNotes}
                  action={sortedMenuNames?.SMALL_BOATS?.[option?.editAccessName]?.chapterActionId}
                />
              }
            </tr>
          );
        });
      }
      const mainRows = boatInfoFromState?.[option?.keyTable].map((el, index) => {
        return (
          <React.Fragment key={index}>
            {el.hasOwnProperty("isActiv") && !el?.isActiv && (
              <tr key={`${index}-deactivated`}>
                {Object.values(option.namePropsDeactivateArrest).map((prop) => {
                  if (prop.key === "offOfficer") {
                    return (
                      <td
                        key={prop.key}
                        id={prop.key}>
                        {Number(el?.[prop.key])
                          ? option.optionsForModalWindow.editType.inputs.offOfficer.options.find(
                              (item) => item.value === Number(el?.[prop.key]),
                            )?.label
                          : el?.[prop.key]}
                      </td>
                    );
                  }
                  return (
                    <td
                      key={prop.key}
                      id={prop.key}>
                      {prop.hasOwnProperty("renderField") ? prop.renderField(el) : el?.[prop.key]}
                    </td>
                  );
                })}
                <EmptyBodyCell
                  mode={mode}
                  option={option}
                  action={sortedMenuNames?.SMALL_BOATS?.[option?.editAccessName]?.chapterActionId}
                />
              </tr>
            )}
            <tr
              key={`${index}-active`}
              className={el?.isActiv === undefined || el?.isActiv ? styles["red-text"] : ""}>
              {Object.values(option.nameProps).map((prop) => {
                if (prop.key === "onOfficer") {
                  return (
                    <td
                      key={prop.key}
                      id={prop.key}>
                      {Number(el?.[prop.key])
                        ? option.optionsForModalWindow.addType.inputs.onOfficer.options.find(
                            (item) => item.value === Number(el?.[prop.key]),
                          )?.label
                        : el?.[prop.key]}
                    </td>
                  );
                }
                return (
                  <td
                    key={prop.key}
                    id={prop.key}>
                    {Boolean(prop.type)
                      ? createCell(prop, el)
                      : prop.hasOwnProperty("renderField")
                      ? prop.renderField(el)
                      : el?.[prop.key]}
                  </td>
                );
              })}
              <EditButton
                mode={mode}
                option={option}
                el={el}
                cardStatus={boatInfoFromState?.statusOfApp === 2}
                handle={handleEditNotes}
                action={sortedMenuNames?.SMALL_BOATS?.[option?.editAccessName]?.chapterActionId}
              />
            </tr>
          </React.Fragment>
        );
      });
      return additionalRows ? [...additionalRows, ...mainRows] : mainRows;
    } else {
      return (
        <tr>
          {Object.values(option.nameProps).map((prop) => {
            return (
              <td
                key={prop.key}
                id={prop.key}>
                {boatInfoFromState?.[option?.keyTable]?.[prop.key]}
              </td>
            );
          })}
        </tr>
      );
    }
  };

  const handleCloseButton = () => {
    navigate(-1);
  };

  const resolveSubmit = (data) => {
    const newErrors = {};
    if (!boatInfoFromState.ownerInformation[0].oblId) {
      newErrors.ownerInformation = "Таблица обязательна для заполнения";
    }
    if (!boatInfoFromState.boatDimensions[0].boatLength) {
      newErrors.boatDimensions = "Таблица обязательна для заполнения";
    }
    setTableErrors(newErrors);

    if (Object.values(newErrors).some((item) => item !== "")) return;

    for (const key in data) {
      if (key.includes("IdName") && data[key]?.value !== undefined) {
        const newKey = key.replace("IdName", "");
        data[newKey] = data[key].value;
        delete data[key];
      }
    }

    if (boatInfoFromState?.statusOfApp === 2 && data.boatVin !== boatInfoFromState.mainInformation.boatVin) {
      setFormData({ ...data, regNum: boatInfoFromState.mainInformation.regNum });
      dispatch(getCheckBoatSerialNumber(data));
    } else {
      dispatch(updateBoatInfoApi(boatInfoFromState.cardid, boatInfoFromState, data));
    }
  };

  const handleDeleteFileConfirm = async () => {
    if (fileId) {
      dispatch(deleteBoatFile(fileId));
      setShowConfirmationModal(false);
    }
  };

  const handleCloseApp = () => {
    navigate("/smallboats");
  };

  const setOptionsFromLibs = () => {
    if (
      Object.values(dictionaryReducer.boatTypes).length > 0 &&
      Object.values(dictionaryReducer.kindsBoats).length > 0 &&
      Object.values(dictionaryReducer.allBoatBodyMaterial).length > 0 &&
      Object.values(dictionaryReducer.allSwimmingDifficultyCategory).length > 0
    ) {
      setOptionsForBoat(
        dictionaryReducer.boatTypes,
        dictionaryReducer.kindsBoats,
        dictionaryReducer.allBoatBodyMaterial,
        dictionaryReducer.allSwimmingDifficultyCategory,
      );
    }
    if (Object.values(dictionaryReducer.identificationDocuments).length > 0) {
      setDocOptionsDocumentsFromDictionaries(dictionaryReducer.identificationDocuments);
    }
    if (Object.values(dictionaryReducer.allOblast).length > 0) {
      setOblOptionsFromDictionaries(dictionaryReducer.allOblast);
    }
  };

  useEffect(() => {
    if (checkboatSerialNumber === "success") {
      dispatch(updateBoatInfoApi(boatInfoFromState.cardid, boatInfoFromState, formData));
    } else if (
      checkboatSerialNumber.message &&
      checkboatSerialNumber !== "success" &&
      boatInfoFromState?.statusOfApp === 2
    ) {
      setShowErrorModal(true);
    }
  }, [checkboatSerialNumber]);

  useEffect(() => {
    setOptionsBoatInfo("firstInit", optionsForOfficer);
  }, [directoryLoad]);

  useEffect(() => {
    if (Boolean(optionsForOfficer.length) && !directoryLoad) {
      setDirectoryLoad(true);
    }
  }, [optionsForOfficer]);

  useEffect(() => {
    dispatch(getBoatCardInfo(id));
    return () => {
      dispatch(clearBoatInfo());
    };
  }, []);

  useEffect(() => {
    setOptionsFromLibs();
  }, [dictionaryReducer]);

  useEffect(() => {
    setOptionsFromLibs();
  }, []);

  useEffect(() => {
    if (
      boatInfoFromState.boatArrestsDtos?.findIndex((item) => item.isActiv === undefined || item.isActiv) >= 0
    ) {
      setOptions(handleAddBtn(options.bodyTable.boatArrestsDtos, false));
    } else setOptions(handleAddBtn(options.bodyTable.boatArrestsDtos, true));
  }, [boatInfoFromState.boatArrestsDtos]);

  useEffect(() => {
    if (editDataResult === "success") {
      setRegistrationResult("success");
      setAppId("register");
      setShowResultModal(!showResultModal);
    }
    if (editDataResult === "error") {
      setRegistrationResult("error");
      setShowResultModal(!showResultModal);
    }
  }, [editDataResult]);

  useEffect(() => {
    const firstError = document.querySelector(`.${styles["red-text"]}`);
    if (firstError) {
      firstError.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [tableErrors]);

  useEffect(() => {
    if (boatInfoFromState?.mainInformation) {
      Object.entries(boatInfoFromState?.mainInformation)
        .filter(([_, value]) => value !== null)
        .forEach(([key, value]) => {
          setValue(key, value);
        });
    }
    if (boatInfoFromState?.additionalInformation && boatInfoFromState.additionalInformation.length > 0) {
      Object.entries(boatInfoFromState?.additionalInformation[0])
        .filter(([_, value]) => value !== null)
        .forEach(([key, value]) => {
          setValue(key, value);
        });
    }
  }, [boatInfoFromState?.mainInformation, boatInfoFromState.additionalInformation]);

  return (
    <div className={styles["info-container"]}>
      <form onSubmit={handleSubmit(resolveSubmit)}>
        {Object.values(options?.bodyTable).map((option) => {
          switch (option.keyTable) {
            case options?.bodyTable?.mainInformation.keyTable:
              return (
                <UniversalInputComponent
                  key={option.keyTable}
                  options={options?.bodyTable?.mainInformation}
                  mode={mode}
                  styles={styles}
                  register={register}
                  newData={boatInfoFromState?.mainInformation}
                  control={control}
                  setValue={setValue}
                  errors={errors}
                  clearErrors={clearErrors}
                />
              );
            case options?.bodyTable?.additionalInformation.keyTable:
              if (boatInfoFromState?.statusOfApp === 2) {
                return (
                  <UniversalInputComponent
                    key={option.keyTable}
                    options={options?.bodyTable?.additionalInformation}
                    mode={mode}
                    styles={styles}
                    register={register}
                    newData={boatInfoFromState?.additionalInformation}
                    control={control}
                    setValue={setValue}
                    errors={errors}
                    clearErrors={clearErrors}
                  />
                );
              } else {
                return (
                  <div
                    key={option.keyTable}
                    className={styles["additional-information"]}>
                    <p className={styles[option.classNameCaption]}>{option.caption}</p>
                    {Object.values(option.inputsOptions).map((item) => {
                      return (
                        <div
                          key={item.key}
                          className={styles["additional-info-block"]}
                          id={item.key}>
                          <p className={styles["additional-info-caption"]}>{item.label}</p>
                          <p className={styles["additional-info-text"]}>
                            {boatInfoFromState?.additionalInformation?.[0]?.[item.key] || "—"}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                );
              }

            default:
              return (
                <div key={option.keyTable}>
                  <p className={styles[option.classNameCaption]}>{option.caption}</p>
                  <AddButton
                    mode={mode}
                    option={option}
                    handle={handleAddNewData}
                    action={sortedMenuNames?.SMALL_BOATS?.[option?.editAccessName]?.chapterActionId}
                  />
                  <table
                    className={`${
                      styles[
                        option.classQuantityColumns ? option.classQuantityColumns : option.classNameTable
                      ]
                    } ${styles["table-container"]}`}>
                    <thead>
                      <tr>
                        {Object.values(option.nameProps).map((item) => {
                          return (
                            <th
                              key={item.key}
                              id={item.key}>
                              {item.value}
                            </th>
                          );
                        })}
                        <EmptyHeaderCell
                          mode={mode}
                          option={option}
                          action={sortedMenuNames?.SMALL_BOATS?.[option?.editAccessName]?.chapterActionId}
                        />
                      </tr>
                    </thead>
                    <tbody>{createRow(option)}</tbody>
                  </table>

                  {tableErrors[option.keyTable] && tableErrors[option.keyTable].length > 0 && (
                    <p
                      id={`${option.keyTable}Error`}
                      className={styles["red-text"]}>
                      {tableErrors[option.keyTable]}
                    </p>
                  )}
                </div>
              );
          }
        })}
        <div className={styles["footer-tables"]}>
          {Object.values(options?.footerTable).map((option) => {
            return (
              <div key={option.keyTable}>
                <p className={styles[option.classNameCaption]}>{option.caption}</p>
                <AddButton
                  mode={mode}
                  option={option}
                  handle={handleAddNewData}
                  action={sortedMenuNames?.SMALL_BOATS?.[option?.addAccessName]?.chapterActionId}
                />
                <table className={`${styles[option.classNameTable]} ${styles["table-container"]}`}>
                  <thead>
                    <tr>
                      {Object.values(option.nameProps).map((item) => {
                        return (
                          <th
                            key={item.key}
                            id={item.key}>
                            {item.value}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>{createRow(option)}</tbody>
                </table>
              </div>
            );
          })}
        </div>
        <div className={styles["buttons-container"]}>
          <button
            className={styles["close-btn"]}
            onClick={() => handleCloseButton()}
            type="button">
            Закрыть
          </button>
          {mode === "edit" && (
            <button
              className={styles["save-btn"]}
              type="submit">
              Сохранить
            </button>
          )}
        </div>
      </form>
      {showModal && (
        <BoatInfoModalWindow
          options={optionsForWindow}
          show={showModal}
          setShow={setShowModal}
          clearOptionsModalWindow={clearOptionsModalWindow}
        />
      )}
      {showConfirmationModal && (
        <ConfirmationModal
          isOpen={showConfirmationModal}
          title="Подтверждение действия"
          text={"Вы действительно хотите удалить файл?"}
          textButton={"Подтвердить"}
          onClose={() => {
            setShowConfirmationModal(false);
            setFileId(null);
          }}
          onConfirm={handleDeleteFileConfirm}
        />
      )}
      {showErrorModal && (
        <ConfirmationModal
          isOpen={showErrorModal}
          text={checkboatSerialNumber.message}
          onClose={() => {
            setShowErrorModal(false);
          }}
        />
      )}
      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          handleCloseApp={handleCloseApp}
        />
      )}
    </div>
  );
}

export default BoatInfo;
